import { validateEmail } from "../../utils/helper";

const useValidate = () => {
  return (schema) => {
    if (schema && Array.isArray(schema)) {
      for (const field of schema) {
        // Required validation
        if (
          field.required &&
          (field.value === undefined ||
            field.value === null ||
            field.value === "")
        ) {
          return `${field.field} is required.`;
        }

        // Email validation
        if (field.isEmail && field.value && !validateEmail(field.value)) {
          return `${field.field} is not valid.`;
        }

        // Array validation
        if (
          field.isArray &&
          (!Array.isArray(field.value) || field.value.length === 0)
        ) {
          return `${field.field} is empty.`;
        }

        // Custom validation
        if (field.custom && typeof field.custom === "function") {
          const customResponse = field.custom();

          if (customResponse !== true) {
            return customResponse;
          }
        }
      }
    }

    return true;
  };
};

export default useValidate;
